import { api } from "@/_store/api-client";
import {
  ICreateAcceptanceRequest,
  ICreateAcceptanceResponse,
  IGetCurrentUserResponse,
  IGetPersonalAgreementResponse,
  IGetReportHistoryRequest,
  IGetReportHistoryResponse
} from "./contracts";

export const currentUser = api.injectEndpoints({
  endpoints: (builder) => ({
    getCurrentUser: builder.query<IGetCurrentUserResponse, void>({
      query: () => ({
        url: "/api/v1/users/auth/current_user/",
        method: "GET",
      }),
      providesTags: ["CurrentUser"],
    }),
    getReportHistory: builder.query<IGetReportHistoryResponse, IGetReportHistoryRequest>({
      query: ({ page, size }) => ({
        url: "/api/v1/reports-history/",
        method: "GET",
        params: { page, size },
      }),
      providesTags: ["ReportHistory"],
    }),
    getPersonalDataAgreement: builder.query<IGetPersonalAgreementResponse, void>({
      query: () => ({
        url: "/api/v1/users/personal_data_agreement/",
        method: "GET",
      }),
      providesTags: ["PersonalAgreement"],
    }),
    createAcceptance: builder.mutation<ICreateAcceptanceResponse, ICreateAcceptanceRequest>({
      query: (requestBody) => ({
        url: "/api/v1/users/acceptance/ ",
        method: "POST",
        body: requestBody,
      }),
      invalidatesTags: ["CreateAcceptance"],
    })
  }),
  overrideExisting: false,
});

export const {
  useGetCurrentUserQuery,
  useLazyGetCurrentUserQuery,
  useGetReportHistoryQuery,
  useGetPersonalDataAgreementQuery,
  useCreateAcceptanceMutation,
} = currentUser;
